
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, {
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      },
      maintainAspectRatio: true,
      legend: {
        display: false,
        labels: {
          boxWidth: 0
        }
      },
      cutoutPercentage: 90

    });
  }
};
